<script lang="ts">
	/* https://svelte-modals.mattjennings.io/api */
	import { closeModal } from 'svelte-modals'
	import SecondaryButton, { SecondaryBtnColors } from '../atoms/SecondaryButton.svelte'
	import { t } from '../../i18n/i18n'
	import { fly } from 'svelte/transition'
	import Tooltip from '../atoms/Tooltip.svelte'
	import { TooltipPlacements } from '../types/enums'
	import Icon from '../atoms/Icon.svelte'
	import closeIcon from '@/icons/icon_close.svg'

	// provided by <Modals/>
	export let isOpen
	export let title
	export let ttContent
	export let content = ''
	let paddingHorizontal = '1.375rem'
	let paddingTop = '0.75rem'
	let paddingBottom = '0.688rem'
	let borderRadius = '2px'
</script>

{#if isOpen}
	<div
		role="dialog"
		class="modal"
		in:fly={{ y: -100, duration: 600 }}
		out:fly={{ y: -200, duration: 600 }}
	>
		<div class="contents-large">
			<div class="close-icon-top">
				<Icon src={closeIcon} name="close" size={32} clickable on:click={closeModal} />
			</div>
			<div class="contents-header">
				<h1 class="header">{@html title}</h1>
				<Tooltip
					maxWidthTtip={370}
					msg={ttContent}
					placementTtip={TooltipPlacements.RIGHT}
					isHtml
				/>
			</div>

			<div class="actual-content">
				{#if content && content !== ''}
					<div>{@html content}</div>
				{/if}
				<slot name="content" />
			</div>
			<div class="actions">
				<SecondaryButton
					label={$t('UI.button.close')}
					color={SecondaryBtnColors.GREEN}
					on:click={closeModal}
					{paddingHorizontal}
					{paddingBottom}
					{paddingTop}
					{borderRadius}
					sizeAdaptingToText
				/>
			</div>
		</div>
	</div>
{/if}

<style lang="scss">
	@use '$styles/modals';
	@use '$styles/global';
	@use '$styles/breakpoints';

	.modal {
		top: 1rem;
	}

	h1.header {
		margin: 0;
	}

	.actual-content {
		width: 100%;

		@include global.flex-col;

		overflow: auto;

		& > div {
			width: 100%;
		}
	}

	.actions {
		@include global.flex-row(0.375rem, $justify: flex-end);

		width: 100%;
		margin-top: 1.125rem;
		border-radius: 0 0 6px 6px;
		margin-right: 5.75rem;
		margin-bottom: 1.375rem;
	}

	.contents-large {
		@include global.roboto-font(1rem);
		@include global.flex-col($justify: space-between);

		position: relative;
		width: 920px;
		max-width: 100%;
		line-height: 150%;
		border-radius: 6px;
		padding: 1.75rem 4.75rem;
		background: white;
		pointer-events: auto;
		box-shadow:
			0 20px 25px -5px rgba(9, 9, 9, 0.1),
			0 10px 10px -5px rgba(9, 9, 9, 0.04);
		margin: 1rem 0;
	}

	.close-icon-top {
		position: absolute;
		right: 2.5rem;
		top: 1.75rem;
	}

	.contents-header {
		@include global.flex-row(0.375rem, $justify: flex-start);

		align-self: flex-start;
		margin-top: 3.125rem;
		margin-bottom: 1rem;
		width: 100%;

		& h2 {
			@include global.roboto-font(24px, 500, 16px, #1e1e1e);

			letter-spacing: -0.176px;
			margin-right: 5px;
		}
	}

	@media screen and (max-width: breakpoints.$small) {
		.contents-large {
			padding: 1.5rem 3rem;
		}

		.close-icon-top {
			position: absolute;
			right: 1.75rem;
			top: 1.25rem;
		}
	}

	@media screen and (max-width: breakpoints.$xsmall) {
		.contents-large {
			padding: 1.25rem 2rem;
		}

		div.modal[role='dialog'] {
			padding: 61px 0.5rem 1rem;
		}
	}
</style>
